import { borderRadius } from '#/common/hooks/useClientTheme';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';

const Styles = styled.div`
  .dx-checkbox.dx-checkbox-checked .dx-checkbox-icon {
    font-size: 14px;
  }
  .dx-scrollable-content {
    background-color: ${color('custom', 'invertedText')};
  }
  .dx-scrollview-content {
    padding: 0;
    padding-bottom: 20px;

    .dx-item.dx-list-item.dx-state-hover {
      background-color: ${color('custom', 'invertedText')};
    }

    .dx-item.dx-list-item.dx-state-focused {
      background-color: ${color('custom', 'invertedText')};
    }
    .dx-item.dx-list-item.dx-state-active {
      background-color: ${color('custom', 'invertedText')};
    }
    .dx-item {
      margin: 0;

      .dx-item-content.dx-list-item-content {
        padding: 16px 0 0;
      }
    }
  }
`;

export default Styles;
